import { useUserInfo } from "../../context/user";
import IntegrationSignin from "./Auth/Components/Signin";
import IntegrationSignup from "./Auth/Components/Signup";
import IntegrationsApp from "./Integration";

const useRoutes = () => {
  const [user, , , , userActiveLocation] = useUserInfo()
  const isAuthenticated = !!user || Object.keys(user)?.length > 0

  const routes = [
    {
      type: "collapse",
      name: "Sign Up",
      key: "integration-sign-up",
      route: "/sign-up",
      component: <IntegrationSignup />,
    },
    {
      type: "collapse",
      name: "Sign In",
      key: "integration-sign-in",
      route: "/sign-in",
      component: <IntegrationSignin />,
    },
    {
      type: "collapse",
      name: "Sign In",
      key: "integration-app",
      route: "/",
      guard: {
        valid: isAuthenticated && user.user_type !== undefined && user?.user_type === 'integration',
        redirect: userActiveLocation?.id ? `/integration-app/sign-in?id=${userActiveLocation?.id}` : '/integration-app/sign-in',
      },
      component: <IntegrationsApp />,
    },
  ];
  return routes
}

export default useRoutes;
